module.exports = __webpack_public_path__ + "assets/chunjie.9fb8d008.svg";